import { useEffect } from "react";
import { useUserSlice } from "src/store/features/user.slice";

declare global {
  interface Window {
    adoraStart: (settings: {
      orgId: string;
      uid?: string;
      properties?: Record<string, string | boolean>;
      language?: string;
    }) => void;
  }
}

export const AdoraIntegration = () => {
  const {
    details: { customerId },
    broker: { name },
    is2FAEnabled,
  } = useUserSlice();

  useEffect(() => {
    // Create script element
    // Get email from session storage
    const email = sessionStorage.getItem("email");
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://adora-cdn.com/adora-start.js";

    // Set up the onload handler
    script.onload = () => {
      // Call adoraStart with hardcoded orgId
      window.adoraStart({
        orgId: "e3b9f686-bd4e-4b16-a278-836a005fa8f2",
        uid: customerId,
        properties: {
          email: email || "",
          broker: name || "",
          is2FAEnabled: is2FAEnabled === true ? "Enabled" : "Disabled",
        },
      });
    };

    // Append the script to the document head
    document.head.appendChild(script);

    // Cleanup function to remove the script when component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, [customerId]);

  return null;
};
